<template>
  <div>
    <!-- 退换货办理 -->
    <div class="rj-breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>合同列表</el-breadcrumb-item>
        <el-breadcrumb-item>合同基本信息</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <baseInfoCheckReturn :info="info" />
    <rj-tabs v-model="tabsActive">
      <!-- <rj-tab-pane name="1" label="订单明细">
        <productCheck :str-contract-code="contractNum" :init-info="info" />
      </rj-tab-pane> -->
      <rj-tab-pane name="1" label="合同明细">
        <contractual-detailed ref="detailedRef" />
      </rj-tab-pane>
      <rj-tab-pane name="3" label="订单明细">
        <contractual-product :str-contract-code="this.$route.query.number" :init-info="info" :sales-type="info.rsalesSettlementModes" />
      </rj-tab-pane>
      <rj-tab-pane name="7" label="约定交付日期">
        <delivery-date :str-contract-code="this.$route.query.number" :contract-id="info.contractId" type-view="return" />
      </rj-tab-pane>
      <rj-tab-pane name="2" label="发货明细">
        <logistics-info :str-contract-code="this.$route.query.number" />
      </rj-tab-pane>
      <rj-tab-pane name="6" label="序列号明细">
        <serial-number id="" :str-contract-code="this.$route.query.number" />
      </rj-tab-pane>
      <rj-tab-pane name="4" label="开票明细">
        <invoice-details :str-contract-code="this.$route.query.number" :contract-id="info.contractId" type-view="return" />
      </rj-tab-pane>
      <rj-tab-pane name="8" label="销退明细">
        <el-table :data="tableData1" border style="width: 100%">
          <el-table-column type="index" width="60" label="序号" align="left" fixed="left" />
          <el-table-column prop="" label="订单号" align="left" fixed="left" />
          <el-table-column prop="rcreatedTime" label="销退日期" align="left" />
          <el-table-column prop="rnewContractNum" label="销退单号" align="left" />
          <el-table-column prop="rMaterialNum" label="物品代码" align="left" />
          <el-table-column prop="rproductSalesName" label="产品名称" align="left" />
          <el-table-column prop="rproductNum" label="销退数量" align="left" />
        </el-table>
      </rj-tab-pane>
      <rj-tab-pane name="9" label="分配明细">
        <el-table :data="tableData2" border style="width: 100%">
          <el-table-column type="index" width="60" label="序号" align="left" fixed="left" />
          <el-table-column prop="rteleNum" label="电汇底单编号" align="left" fixed="left" />
          <el-table-column v-if="this.$route.query.rcontractType === '退货合同'" prop="rrefundAmount" label="订单金额" align="left" width="150" />
          <el-table-column v-if="this.$route.query.rcontractType === '换货合同'" prop="ractualSettlementAmount" label="订单金额" align="left" width="150" />
          <el-table-column prop="rassignAmount" label="已分配金额" align="right" header-align="left" width="150" />
          <el-table-column prop="distributionProportion" label="已分配金额比例" align="right" header-align="left" width="150">
            <template slot-scope="{ row }">
              {{ row.distributionProportion >= 100 ? '100.00' : row.distributionProportion.toFixed(2) }}%
            </template>
          </el-table-column>
          <el-table-column prop="rcreatedBy" label="分配人" align="left" />
          <el-table-column prop="rcreatedTime" label="分配日期" align="left" />
          <!-- 同步ERP状态 -->
          <el-table-column label="同步ERP状态" align="left" width="120">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.rsyncSuccessFlag === false"
                type="text"
                @click="showErrorDetail(scope.row)"
              >
                失败
              </el-button>
              <span v-else>
                {{ scope.row.rsyncSuccessFlag === true ? '成功' : '待抛转' }}
              </span>
            </template>
          </el-table-column>
          <!-- 操作  -->
          <el-table-column label="操作" align="left" width="120">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.buttonState === null && !asSale"
                type="text"
                size="small"
                @click="cancelAllocation(scope.row)"
              >
                撤销分配
              </el-button>
              <el-button
                v-if="scope.row.buttonState === '可查看'"
                type="text"
                size="small"
                @click="showDetail(scope.row)"
              >
                查看
              </el-button>
              <span v-if="scope.row.buttonState !== null && scope.row.buttonState !== '可查看'">
                {{ scope.row.buttonState }}
              </span>
            </template>
          </el-table-column>
        </el-table>
      </rj-tab-pane>

      <!-- <rj-tab-pane name="4" label="退货明细">
        <el-table :data="tableData3" border style="width: 100%">
          <el-table-column prop="stateDateTime" label="序号" align="left" />
          <el-table-column prop="stateDateTime" label="订单号" align="left" width="150" />
          <el-table-column prop="stateDateTime" label="销退日期" align="left" width="150" />
          <el-table-column prop="stateDateTime" label="销退单号" align="left" width="150" />
          <el-table-column prop="stateDateTime" label="物品代码" align="left" width="150" />
          <el-table-column prop="stateDateTime" label="产品名称" align="left" width="150" />
          <el-table-column prop="stateDateTime" label="销退数量" align="left" width="150" />
        </el-table>
      </rj-tab-pane> -->
    </rj-tabs>
    <!-- 抛单异常详情 -->
    <el-dialog
      title="分配记录同步ERP状态查看"
      :visible.sync="errorDialogVisible"
      width="500px"
    >
      <div class="error-detail">
        <div class="error-item">
          <div class="error-value error-reason">{{ currentErrorInfo.rsyncFailReason }}</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="errorDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
    <!-- 撤销原因 -->
    <el-dialog v-if="causeRevocationVisible" title="撤销原因" :visible.sync="causeRevocationVisible" width="800px" @close="close">
      <el-input v-model="causeRevocation" type="textarea" maxlength="100" />
      <span slot="footer" class="dialog-footer">
        <el-button type="default" @click="cancel">取消申请</el-button>
        <el-button type="primary" :loading="submitLoading" @click="onSubmit">提交申请</el-button>
      </span>
    </el-dialog>

    <!-- 查看 -->
    <el-dialog
      v-if="examineVisible"
      title="合同基本信息"
      :visible.sync="examineVisible"
      width="800px"
    >
      <examine :id="approvalNumID" />
      <span slot="footer" class="dialog-footer">
        <el-button type="default" @click="examineVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import baseInfoCheckReturn from './baseInfoCheckReturn.vue';
import tabs from '@/components/Tabs/tabs';
import tabPane from '@/components/Tabs/tabPane';
// import history from './history.vue';
// import productCheck from './productCheck.vue';
import { getApproveData, getAssignLogByContractId, assignUndoDistributionAgree } from '@/API';
import contractualDetailed from '../../../Chief/contract/common/contractualDetailed.vue';
import contractualProduct from '../../../Chief/contract/common/contractualProduct';
import deliveryDate from '../../../Chief/contract/common/deliveryDate';
import logisticsInfo from '../../../Chief/contract/common/logisticsInfo';
import serialNumber from '../../../Chief/contract/common/serialNumber';
import InvoiceDetails from '../../../Chief/contract/common/InvoiceDetails';
import examine from './examine.vue';
export default {
  computed: {
    ...mapState({
      asSale: state => state.user.asSale
    })
  },
  data () {
    return {
      tabsActive: '1',
      contractNum: '',
      info: {},
      tableData1: [],
      tableData2: [],
      tableData3: [],
      tableData4: [],
      errorDialogVisible: false,
      currentErrorInfo: {},
      causeRevocation: '', // 撤销原因
      submitLoading: false, // 提交按钮loading状态
      causeRevocationVisible: false,
      postData: {},
      examineVisible: false,
      approvalNumID: 0
    };
  },
  props: {

  },
  mounted () {
    this.initData();
  },
  methods: {
    showDetail (val) {
      this.approvalNumID = val.rid;
      this.examineVisible = true;
    },
    cancelAllocation (row) {
      this.causeRevocationVisible = true;
      this.postData.ids = [row.rid];
    },
    cancel () {
      this.causeRevocationVisible = false;
      this.submitLoading = false;
      this.causeRevocation = '';
    },
    close () {
      this.cancel();
    },
    onSubmit () {
      if (!this.causeRevocation) {
        this.$message.warning('撤销原因不能为空');
        return;
      }
      this.postData.type = 1;
      let type = this.$route.query.type ? this.$route.query.type : 1;
      this.postData.type = type;
      this.postData.reason = this.causeRevocation;
      this.submitLoading = true;
      assignUndoDistributionAgree(this.postData).then((res) => {
        this.submitLoading = false;
        let json = res.data;
        if (json.status === '200') {
          this.$message({
            type: 'success',
            message: '提交成功!'
          });

          this.initData();
          this.close();
        }
      }).catch(() => {
        this.submitLoading = false;
      });
    },
    submit () {
      let history = this.$refs.history.rejectedList;
      console.log(history);
    },
    async initData () {
      var res = await getApproveData(this.$route.query.rcontractId, this.$route.query.rcontractType, this.$route.query.action);
      const json = res.data;
      if (json.status === '200') {
        this.$nextTick(() => {
          this.info = json.data.baseInfoModelVO;
          this.$refs.detailedRef.initData(json.data.baseInfoModelVO);
          this.tableData1 = json.data.addressMOdelVOS[0].addressList[0].contractProductList;
        });
      }

      var res2 = await getAssignLogByContractId(this.$route.query.rcontractId);
      const json2 = res2.data;
      if (json2.status === '200') {
        this.$nextTick(() => {
          this.tableData2 = json2.data;
          this.tableData2 && this.tableData2.forEach((item) => {
            item.rrefundAmount = this.info.rrefundAmount;
            item.ractualSettlementAmount = this.info.ractualSettlementAmount;
          });
        });
      }
    },
    // 显示错误详情
    showErrorDetail (row) {
      this.currentErrorInfo = row;
      this.errorDialogVisible = true;
    }
  },
  components: {
    contractualDetailed,
    baseInfoCheckReturn,
    'rj-tab-pane': tabPane,
    'rj-tabs': tabs,
    contractualProduct,
    deliveryDate,
    logisticsInfo,
    serialNumber,
    InvoiceDetails,
    examine
    // productCheck
  }
};
</script>

<style>
.error-item {
  margin-bottom: 16px;
  line-height: 1.6;
}
.error-label {
  font-weight: 500;
  color: #606266;
  min-width: 80px;
  display: inline-block;
}
.error-value {
  color: #303133;
  word-break: break-all;
}
.error-reason {
  white-space: pre-wrap;
}
</style>
